export default __webpack_public_path__ + "static/media/Screenshot (1079).d3510198.png";